<template>
<div style="height: 100%;">
  <div class="zj-emergency-videomonitor-panel" v-if="!isVisiable">
    <div class="zj-emergency-videomonitor-header">
      <span class="header-title">视频监控</span>
      <div class="arrow-pic"></div>
      <div class="icon-spread" @click="handlerVisiable(true)"></div>
    </div>
    <div class="zj-emergency-videomonitor-search-box">
      <input type="text" placeholder="搜索视频监控点" class="zj-emergency-videomonitor-search-box-input" v-model="searchText"/>
      <div class="zj-emergency-videomonitor-search-box-btn" @click="search"></div>
    </div>
    <div class="zj-emergency-videomonitor-list">
      <div class="zj-emergency-videomonitor-list-container">
        <VideoMonitorControl
          @spread="cameraSpread"
          v-for="item in cameras"
          :key="item.cameraId"
          :cameraId="item.cameraId"
          :autoplay="item.autoplay"
          :cameraName="item.cameraName"
          :cameraIsOnline="item.cameraIsOnline"
          :item="item.item"
          ref="videoCom"
        />
        {{cameras}}
      </div>
    </div>
  </div>
    <el-dialog
      class="emergencyoperations-dialog video-monitor"
      custom-class="bg3"
      top="20vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isVisiable"
      :destroy-on-close="true"
    >
      <VideoMonitorPopup @handlerclose="handlerVisiable(false)"  v-if="isVisiable"/>
    </el-dialog>

    <el-dialog
      class="emergencyoperations-dialog video-monitor"
      custom-class="bg3"
      top="20vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isGrowVisiable"
      :destroy-on-close="true"
    >
      <VideoMonitorGrow
        :cameraId="currentCameraId"
        :cameraName="currentCameraName"
        :cameraIsOnline="currentcameraIsOnline"
        :item="currentcameraItem"
        @spread="cameraSpread"
        @handlerclose="handlerclose"
        v-if="isGrowVisiable"
      />
        <!-- @handlerclose="isGrowVisiable=false" -->
    </el-dialog>
</div>
</template>

<script>
import VideoMonitorControl from "./Component-VideoMonitorControl";
import VideoMonitorPopup from "./Component-VideoMonitor";
import VideoMonitorGrow from "./Component-VideoMonitorGrow";
import MyApis from "../../../../apis";
import { getEquipmentCode, listEquipment, delEquipment, listEquipmentCategory } from "@/api/src/equipment";
export default {
  name: "ZJEmergencyVideoMonitorPanel",
  componentName: "ZJEmergencyVideoMonitorPanel",
  components: {
    VideoMonitorControl: VideoMonitorControl,
    VideoMonitorPopup: VideoMonitorPopup,
    VideoMonitorGrow: VideoMonitorGrow
  },
  data: function() {
    return {
      isVisiable: false,
      isGrowVisiable: false,
      cameras: [],
      camerasList: [],
      currentCameraId: "",
      currentCameraName: "",
      currentcameraIsOnline:false,
      currentcameraItem:{},
      searchText:null,
    };
  },
  created() {
    this.search();
  },
  methods: {
    handlerVisiable(flag){
      this.isVisiable = flag
      this.$emit('changeStyle',flag)
    },
    handlerclose(){
      this.isGrowVisiable=false
      this.cameras.map((item,index) =>{
        if(item.cameraId == this.currentCameraId){
          this.$refs.videoCom[index].play()
        }
      })
    },
    cameraSpread(cameraId, cameraName,cameraIsOnline,item) {
      this.currentCameraId = cameraId;
      this.currentCameraName = cameraName;
      this.currentcameraIsOnline = cameraIsOnline
      this.currentcameraItem = item
      this.isGrowVisiable = true;
    },
    // eslint-disable-next-line no-unused-vars
    search() {
      let that = this;
      getEquipmentCode('monitorEquipment').then(response =>{
        let categoryCode = response.data;
        listEquipment({
          categoryCode,
          pageNum: 1,
          pageSize: 6,
          // onlineStatus:1,
          equipmentName:this.searchText

        }).then(response =>{
          this.camerasList = response.rows;
          this.searchByCondition();
        });
      });
    },
    searchByCondition() {
      let arr = [];
      this.camerasList.forEach((el, index) => {
          arr.push({
            streamType: 1,
            autoplay: false,
            cameraId: el.equipmentCode,
            // cameraId: el.id,
            cameraName: el.equipmentName,
            item: el,
            cameraIsOnline: el.onlineStatus
          });
      });
      this.cameras = arr;
      if (this.cameras.length > 0) {
        this.cameras[0].autoplay = true;
      }
    }
  }
};
</script>